import { render, staticRenderFns } from "./SelectApiReadOnly.vue?vue&type=template&id=54d43fac&"
import script from "./SelectApiReadOnly.vue?vue&type=script&lang=js&"
export * from "./SelectApiReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d43fac')) {
      api.createRecord('54d43fac', component.options)
    } else {
      api.reload('54d43fac', component.options)
    }
    module.hot.accept("./SelectApiReadOnly.vue?vue&type=template&id=54d43fac&", function () {
      api.rerender('54d43fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select-api/SelectApiReadOnly.vue"
export default component.exports